import { MessageBox } from 'element-ui';
import config from '@/config';

let lastSrcs; //上一次获取到的script地址
const scriptReg = /<script[^>]*src=["'](?<src>[^"'>]+)/gm;

// 获取最新页面中的script链接
async function extractNewScript(){
  const html = await fetch(`/?time_stamp=${Date.now()}`).then((resp) => resp.text())
  scriptReg.lastIndex = 0;
  let result = [];
  let match;
  while ((match = scriptReg.exec(html))){
    result.push(match.groups.src);
  }
  return result;
}

// 是否需要更新
async function needUpdate(){
  const newScripts = await extractNewScript();
  if (!lastSrcs){
    lastSrcs = newScripts;
    return false;
  }
  let result = false;
  if (lastSrcs.length !== newScripts.length) result = true;
  for (let i=0; i<lastSrcs.length; i++){
    if (lastSrcs[i] !== newScripts[i]){
      result = true;
      break;
    }
  }
  lastSrcs = newScripts;
  return result;
}

// 监听文件变化，自动更新
function autoRefresh(){
  let msgboxInstance;

  function fn(){
    setTimeout(async () => {
      const willUpdate = await needUpdate();
      if (willUpdate){
        if (msgboxInstance) MessageBox.close();
        msgboxInstance = MessageBox({
          title: '页面版本有更新，是否刷新页面？',
          showCancelButton: true,
          callback: (action) => {
            if (action === 'confirm') location.reload();
          }
        }).catch(() => {});
      }
      fn();
    }, 30000)
  }
  fn();
}

if (!config.isLocal) autoRefresh();